<template>
  <div v-show="isShow" :style="domStyle" class="fvVideoMonitor">
    <div class="main">
    </div>
    <div class="showLeft" :style={background:listBackgroundColor}>
      <Icon type="ios-arrow-dropright-circle" :style={color:iconColor} v-show="status==1" :size="sizeIcon" class="settings" @click="handlerShow"/>
      <div>
        <p v-for="(item,index) in interval" :style="pTextStyle" :key="item.index" @click="playVideoIndex(index,$event)">
          {{item.name}}
        </p>
      </div>
    </div>
    <Icon type="ios-arrow-dropleft-circle" :style={color:iconColor} v-show="status==0" :size="sizeIcon" class="settings" @click="handlerShow"/>
    <!-- <div id="modal" class="none">
      <div>
        <p id="yes" title="YES" class="yes">是</p>
        <p id="no" title="NO" class="no">否</p>
        <h2>提示信息：</h2>
        <p>是否允许移动鼠标自动播放视频？</p>
      </div>
    </div> -->
    <!-- 请在此添加代码 -->
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<script>
  import flvjs from "flv.js";
  import Axios from "axios";
  import $ from 'jquery';
  export default {
    name: "fvVideoMonitor",
    props: ["primitives", "fvSystemApi", "parentObject"],
    created: function () {
      //组件数据混淆
      this.mixin(this.primitives);
      //组件大小位置初始化
      this.domStyle = {
        position: "absolute",
        left: this.x + "px",
        top: this.y + "px",
        width: this.width + "px",
        height: this.height + "px",
      };
      this.pTextStyle={
        color:this.listFontColor,
        fontSize:this.listFintSize+"px",
      }
      this.sizeIcon=25;
      this.enableStyle = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: "0px",
        backgroundColor: "#ccbfbf",
        opacity: "0.5",
      };
      this.modelsPath = this.parentObject.modelsPath.slice(0);
      this.showLeftWidth=this.showLeftWidth;
      this.iconShowWidth=this.iconShowWidth;
      this.modelsPath.push(this.registerName);
      this.$store.registerModule(this.modelsPath, {
        state: {
          $: this,
        },
      });
      this.urlList=this.urlList;
    //  if(this.excelJson.length!==0 ||this.excelJson!==null ||this.excelJson!==undefined){
    //    for(let i=0;i<this.excelJson.length;i++){
    //      this.interval.push(this.excelJson[i])
    //    }
    //  }
       
    },
    data: function () {
      return {
        //是否可用
        isEnable: false,
        //是否显示
        isShow: true,
        sizeIcon:0,
        videoAll: [],
        //组件大小位置,在created(创建完毕，挂载前)函数中初始化
        domStyle: {},
        pTextStyle:{},
        flvPlayer: null,
        flag:1,
        timer:null,
        urlList: [],
        rtspTransport:[],
        hasRun: false,
        players: [],
        showLeftWidth:"100px",
        iconShowWidth:"100px",
        url:[],
        status:1
       
      };
    },

    mounted() {
      this.srcList();
      var ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[0].className += " " + ranNum;
        setTimeout(function(){
           $("." + ranNum + " .left .p").css("line-height",$("." + ranNum + " .top").height()+"px");
           $("." + ranNum + " .left .p").html("视频加载中.....");
        },1000)
        
      // let oModal = document.querySelector("#modal");
      // let oYes = document.querySelector("#yes");
      // let oNo = document.querySelector("#no");
      // let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      // if (userAgent.indexOf("Chrome") > -1) {
      //   //判断是否是Chrome浏览器
      //   oModal.className = "modal";
      //   oYes.onclick = function () {
      //     //选择是
      //     oModal.className = "none";
      //   };
      //   oNo.onclick = function () {
      //     //选择否
      //     oModal.className = "none"; //隐藏模态框，无自动播放
      //     var iid = document.getElementsByClassName("videoElement");
      //     for (var j = 0; j < iid.length; j++) {
      //       iid[j].onmouseover = null;
      //     }
      //   };
      // }
    },

    methods: {
      //切换列表
      playVideoIndex(index,e){
        e.currentTarget.style.background="#0078D7";
        let sibling = this.siblings(e.currentTarget);
        for(var j = 0; j < sibling.length; j++){
            sibling[j].style.background="";  //这样就可以对所有的兄弟节点执行你需要的操作了
        }
        let name=e.currentTarget.innerText;
        // this.closePlayer();
        if(this.showNum<this.interval.length){
        //   // for(let i=0;i<this.interval.length;i++){
            if(this.interval[index].name==name){
              for(var k=0;k<this.urlList.length;k++){
                if(this.interval[index].tagName==this.urlList[k]){
                  if (this.Alliid[k].paused){
 
                    this.Alliid[k].play();

                    }else{

                      this.Alliid[k].pause();

                    }

                }else if(this.urlList.indexOf(this.interval[index].tagName)==-1){
                  this.urlList.push(this.interval[index].tagName);
                  this.rtspTransport.push(this.interval[index].rtspTransport);
                  this.urlList.shift();
                  this.rtspTransport.shift();
                  this.flvjsPlayCreate();
                  $(".p").html("视频加载中...");
                }
              }
              
           
            }
          // this.flvjsPlayCreate(); 
        }else{
          if(this.interval[index].name==name){
              for(var k=0;k<this.urlList.length;k++){
                if(this.interval[index].tagName==this.urlList[k]){
                  if (this.Alliid[k].paused){
 
                    this.Alliid[k].play();

                    }else{

                      this.Alliid[k].pause();

                    }

                }
              }
            }
        }
      },
       //获取所有的兄弟节点
      siblings(elm){
          let a = [];    //保存所有兄弟节点
          let p = elm.parentNode.children; //获取父级的所有子节点
          for(let i = 0; i < p.length; i++){  //循环
              if(p[i].nodeType == 1 && p[i] != elm){  //如果该节点是元素节点与不是这个节点本身
                  a.push(p[i]);      // 添加到兄弟节点里
              }
          } 
      
        return a;
      },
     //折叠
     handlerShow(){
        var ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[1].className +=" "+ranNum;
        this.$el.children[0].className+=" "+ranNum+1;
      
      if(window.getComputedStyle(this.$el.children[1]).display=="none"){
          this.status=1;
          $("."+ranNum +1).animate({width:this.showLeftWidth},1000);
          this.$el.children[1].children[0].style.left=0;
          $("."+ranNum +'.showLeft').animate({width:'toggle'},200);
          this.$el.children[0].style.width=this.showLeftWidth;
        }else{
          this.status=0;
          $("."+ranNum +1).animate({width:this.iconShowWidth},1000);
          this.$el.children[2].style.left="97%";
          $("."+ranNum +'.showLeft').animate({width:'toggle'},200); 
          this.$el.children[0].style.width=this.iconShowWidth;
        }
        this.$el.children[0].style.height = this.domStyle.height;
        this.rowOrCol();
        this.videoSize();
     },
      closePlayer() {
        for (var j = 0; j < this.players.length; j++) {
          if (this.players[j] != null) {
            this.players[j].unload();
            this.players[j].detachMediaElement();
            this.players[j].destroy();
            this.players[j] = null;
          }
        }
        this.players = [];
        this.urlList = [];
      },
      //生成随机数
      getRanNum() {
        var result = [];
        for (var i = 0; i < 4; i++) {
          var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
          //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
          result.push(String.fromCharCode(65 + ranNum));
        }
        return result.join('');
      },
      //计算盒子生成几行几列
      rowOrCol(){
        var mainHeight = parseInt(this.$el.children[0].style.height);
        var mainWidth = parseInt(this.$el.children[0].style.width);
        var count = this.showNum; //盒子数量
        var hTemp = 50;
        var wTemp = 100;
        var Row = 0; //设定横向盒子个数
        var col = 0;
        var finNum = 0;
        //根据个数计算几行几列显示
        var calculation = function (width, height, count) {
          wTemp = width;
          hTemp = height;
          count = count;
          if (wTemp > hTemp) {
            Row = count;
            col = 0;
            var proportion = parseFloat(hTemp / wTemp);
            // var browserScale = parseFloat(mainHeight / mainWidth);
            // if (browserScale >= 0.5) {
            //   proportion = proportion + 0.2;
            // }
            // if (browserScale < mainWidth / (count * wTemp)) {
            //   proportion = proportion + 0.2;
            // }
            for (; col / Row < proportion;) {
              col++;
              Row = Math.ceil(count / col);
            }
          } else if (wTemp == hTemp) {
            col++;
          } else {
            Row = 0;
            col = count;
            var proportion = parseFloat(wTemp / hTemp);
            var browserScale = parseFloat(mainWidth / mainHeight);
            for (; Row / col < proportion;) {
              Row++;
              col = Math.ceil(count / Row);
            }
          }
          return {
            hTemp,
            wTemp,
            count,
            Row,
            col,
          };
        };
        var result = calculation(wTemp, hTemp, count);
        if (result.count % result.Row == 0) {
          result.col = result.count / result.Row;
          finNum = result.Row;
        } else {
          result.col = (result.count - (result.count % result.Row)) / result.Row + 1;
          finNum = result.count % result.Row;
        }

        //以下方法算宽高
        result.wTemp = mainWidth / result.Row;
        result.hTemp = mainHeight / result.col;
        //以下方法算宽高   确保宽高都为整数
        if (mainWidth % result.Row == 0) {
          result.wTemp = mainWidth / result.Row;
          if (mainHeight % result.col == 0) {
            result.hTemp = mainHeight / result.col;
          } else {
            result.hTemp = (mainHeight - (mainHeight % result.col)) / result.col;
          }
        } else {
          if (mainHeight % result.col == 0) {
            result.hTemp = mainHeight / result.col;
          } else {
            result.hTemp = (mainHeight - (mainHeight % result.col)) / result.col;
          }
        }
        this.getdiv = result;
        this.finNum = finNum;
      },
      Calculation() {
        // //产生随机字母 
        // var ranNum = this.getRanNum();
        // //给domo节点添加class
        // this.$el.children[0].className +=" "+ranNum;
        // var main = document.querySelector("."+ranNum);
        // var main = this.$el.children[0];
        let showList=this.$el.children[1];
        if(window.getComputedStyle(showList).display=="none"){
          this.$el.children[0].style.width = this.iconShowWidth;
          this.status=0;
        }else{
          this.$el.children[0].style.width = this.showLeftWidth;
          this.status=1;
        }
        this.$el.children[0].style.height = this.domStyle.height;
        this.rowOrCol();
      },
      //改变视频大小
      videoSize(){
        var str = "";
        this.rowIndex = 0;
        var index = 0;
        //产生随机字母 
        var ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[0].className += " " + ranNum;
        var top = document.querySelectorAll("." + ranNum + " .top");
        for (var i = 0; i < this.getdiv.Row; i++) {
          for (var j = 0; j < this.getdiv.col - 1; j++) {
            var topIndex = top[index++];
            topIndex.style.width = this.getdiv.wTemp + "px";
            topIndex.style.height = this.getdiv.hTemp + "px";
            topIndex.style.top = this.getdiv.hTemp * j + "px";
            topIndex.style.left = this.getdiv.wTemp * i + "px";
          }
        }
        for (var i = 0; i < this.finNum; i++) {
          var topIndex = top[index++];
          topIndex.style.width = this.getdiv.wTemp + "px";
          topIndex.style.height = this.getdiv.hTemp + "px";
          topIndex.style.top = this.getdiv.hTemp * (this.getdiv.col - 1) + "px";
          topIndex.style.left = this.getdiv.wTemp * i + "px";
        }
      },
      //设置伸缩改变视频大小
      setvideo() {
        this.Calculation();
        this.videoSize();
      },
      //生成视频
      getVideo() {
        this.Calculation()
        var str = "";
        for (var i = 0; i < this.getdiv.Row; i++) {
          for (var j = 0; j < this.getdiv.col - 1; j++) {
            str += `<div class="top" name="${i}${j}" style="width:${this.getdiv.wTemp}px;height:${this.getdiv.hTemp}px;position: absolute;top:${this.getdiv.hTemp * j}px;left:${this.getdiv.wTemp * i}px">
                <div class="left">
                <div class="p"></div>
                  <video class="videoElement" muted controls="controls" onmouseover="play(this)" style="object-fit: fill">
                  </video>
                </div>
              </div>`;
          }
        }
        for (var i = 0; i < this.finNum; i++) {
          str += `<div class="top" name="${i}" style="width:${this.getdiv.wTemp}px;height:${this.getdiv.hTemp}px;position: absolute;top:${this.getdiv.hTemp * (this.getdiv.col - 1)}px;left:${this.getdiv.wTemp * i}px">
            <div class="left">
            <div class="p"></div>
              <video class="videoElement" muted controls="controls" onmouseover="play(this)" style="object-fit: fill">
              </video>
            </div>
          </div>`;
        }

        this.$el.children[0].innerHTML += str;
        // this.$el.children[0].appendChild(str);
        
      },
      srcList(){
        this.getVideo();
        if(this.showNum>this.interval.length){
          for(var i=0;i<this.interval.length;i++){
            this.urlList.push(this.interval[i].tagName);
            this.rtspTransport.push(this.interval[i].rtspTransport);
          }
     
        }else{
          for (var d = 0; d < this.showNum; d++) {
         
            this.urlList.push(this.interval[d].tagName);
            this.rtspTransport.push(this.interval[d].rtspTransport);
       
          }
        }
        
        this.flvjsPlayCreate();
      },
      flvjsPlayCreate(){
        if (flvjs.isSupported()) {
          //产生随机字母 
          var ranNum = this.getRanNum();
          //给domo节点添加class
          this.$el.children[0].className += " " + ranNum;
          var iid = document.querySelectorAll("." + ranNum + " .videoElement");
          // var iid = document.getElementsByClassName("videoElement");
          this.Alliid = iid;
          for (let a = 0; a < this.players.length; a++) {
            if (typeof this.players[a] !== "undefined") {
              if (this.players[a] != null) {
                this.players[a].unload();
                this.players[a].detachMediaElement();
                this.players[a].destroy();
                this.players[a] = null;
              }
            }
          }
          this.players = [];
          this.flvPlayer = null;
          for (var j = 0; j < iid.length; j++) {
            this.flvPlayer = flvjs.createPlayer({
              type: "flv",
              url: "ws://" + window.location.host + "/" + "video/" + this.backgroundName + "/" + this.urlList[j] + "/" + this.rtspTransport[j],
            //   url:"ws://196.168.66.186:3200/video/" +this.backgroundName +"/" +this.urlList[j] + "/" + this.rtspTransport[j],
              isLive: true,
            }, {
              SourceBuffer: true,
              enableStashBuffer: false,
              autoCleanupMaxBackwardDuration: 60,
              autoCleanupMinBackwardDuration: 30,
              statisticsInfoReportInterval: 1000,
              stashInitialSize: 128 * 1024, // 减少首桢显示等待时长
              enableDurationMonitor: true, // true表示监测当前直播流延时，当发现延时过大时，主动追赶
              decreaseDurationStep: 2, // 每次追赶至缓冲区末尾之前的多少秒

            });
            this.flvPlayer.on(flvjs.Events.METADATA_ARRIVED, () => {
              console.log('--== 数据加载完成 ==--');
            });

            this.flvPlayer.on(flvjs.Events.MEDIA_SOURCE_ENDED, () => {
              console.log('--== 媒体源结束，通常意味着服务器停止推流 ==--');
            });
            this.flvPlayer.on(flvjs.Events.MEDIA_SOURCE_CLOSE, () => {
              console.log('--== 媒体源关闭，不显示源代码视图 ==--');
            });
            this.flvPlayer.on(flvjs.Events.ERROR, (errType, errDetail) => {
              console.log('--== flvjs error, type:' + errType + ', detail:' + errDetail + ' ==--');
              console.log('--== should set a timer(for example, 3 seconds) to reload current flv ==--');
            });
            this.flvPlayer.attachMediaElement(iid[j]);
            this.flvPlayer.pause();
            this.flvPlayer.load();
            this.players.push(this.flvPlayer);
          }
        }
      },
      /*
              参数：src 原json数据
              作用：混淆数据到当前对象
          */
      mixin(src) {
        for (var key in src) {
          this[key] = src[key];
        }
      },
      /*
              参数：e 鼠标信息
                   domScale 窗口放大、缩小、偏移等信息
              作用：鼠标事件调用函数，无必要可不进行任何处理
          */
      doFixedEvent(e, domScale) {},
      /*
              参数：无
              作用：系统周期调用
          */
      onTimer() {
        for (var j = 0; j < this.Alliid.length; j++) {
          if (this.Alliid[j].readyState == 0) {
            this.Alliid[j].parentNode.children[0].style.display = "block";
            this.Alliid[j].style.display = "none";
            if(this.flag==1){
                setTimeout(()=>{
                   $(".p").html("视频播放错误");
                 },30000);
                  this.flag = 0;
            }else{
                this.timer = setTimeout(function(){this.flag=1;},1000*10);
            }
          } else {
            this.Alliid[j].parentNode.children[0].style.display = "none";
            if(this.isAutoPlay){
                // this.Alliid[j].setAttribute("autoplay","autoplay");
                if (this.Alliid[j].paused){
                    this.Alliid[j].play();
                }else{
                    this.Alliid[j].play();
                }
                
            }
            this.Alliid[j].style.display = "block";
          }
        }

        if (this.isEnable) return;
      },
      /*
              参数：无
              作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
          */
      onClose() {
        return new Promise((resolve) => {
          resolve();
        });
      },
      /*
              参数：scaleObj 重绘信息
              作用：组件需要重绘时触发
          */
      reDraw(scaleObj) {
       let cureeWidth=parseInt(this.width * (scaleObj.sx + scaleObj.zoom))*0.24;
       let iconWidth=parseInt(this.width * (scaleObj.sx + scaleObj.zoom))*0.03;
        this.showLeftWidth=parseInt(this.width * (scaleObj.sx + scaleObj.zoom))-cureeWidth+'px';
        this.iconShowWidth=parseInt(this.width * (scaleObj.sx + scaleObj.zoom))-iconWidth+'px';
        this.domStyle.left = parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + "px";
        this.domStyle.top = parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px";
        this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
        this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
        this.sizeIcon=parseInt(30 * (scaleObj.sx + scaleObj.zoom));
        this.pTextStyle.fontSize = parseInt(this.listFintSize * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) +"px";
        this.setvideo();
        var ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[0].className += " " + ranNum;
        $("." + ranNum + " .left .p").css("line-height",$("." + ranNum + " .left .p").height()+"px");
      },
      /*
              参数：isShow 显示隐藏
              作用：设置组件整体显隐
          */
      Show: function (isShow) {
        this.isShow = isShow ? true : false;
      },

      /**
       *
       *  {index,videoChannel}索引，视频通道
       * {videoChannel}返回索引位置的新视频通道
       * {rtspTransport}视频协议模式
       */

      switchCameras(index, videoChannel , rtspTransport) {
        var ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[0].className += " " + ranNum;
        let num = document.querySelectorAll("." + ranNum + " .videoElement").length;
        console.log(num);
        if(parseFloat(index)+1>num) {
            alert("视频下标设置不对,下标不能大于显示个数设置");
            return;
        }
        var changeVideo = document.querySelectorAll("." + ranNum + " .videoElement")[index];
        changeVideo.removeAttribute("src");
        if (flvjs.isSupported()) {
          var flvPlay = flvjs.createPlayer({
            type: "flv",
            url: "ws://" + window.location.host + "/" + "video/" + this.backgroundName + "/" + videoChannel + "/" + rtspTransport,
            // url:"ws://196.168.66.186:3200/video/"+this.backgroundName +"/"+videoChannel + "/" + rtspTransport,
            isLive: true,
          }, {
            SourceBuffer: true,
            enableStashBuffer: false,
            autoCleanupMaxBackwardDuration: 60,
            autoCleanupMinBackwardDuration: 30,
            statisticsInfoReportInterval: 1000,
            stashInitialSize: 128 * 1024, // 减少首桢显示等待时长
            enableDurationMonitor: true, // true表示监测当前直播流延时，当发现延时过大时，主动追赶
            decreaseDurationStep: 2, // 每次追赶至缓冲区末尾之前的多少秒

          });
          flvPlay.on(flvjs.Events.METADATA_ARRIVED, () => {
            console.log('--== 数据加载完成 ==--');
          });

          flvPlay.on(flvjs.Events.MEDIA_SOURCE_ENDED, () => {
            console.log('--== 媒体源结束，通常意味着服务器停止推流 ==--');
          });
          flvPlay.on(flvjs.Events.MEDIA_SOURCE_CLOSE, () => {
            console.log('--== 媒体源关闭，不显示源代码视图 ==--');
          });
          flvPlay.on(flvjs.Events.ERROR, (errType, errDetail) => {
            console.log('--== flvjs error, type:' + errType + ', detail:' + errDetail + ' ==--');
            console.log('--== should set a timer(for example, 3 seconds) to reload current flv ==--');
          });
          flvPlay.attachMediaElement(changeVideo);
          flvPlay.load();

        }

      },
      /*
      折叠方法
      */
  
      /*
              参数：isEnable 是否可用
              作用：设置组件是否可用
          */
      Enable: function (isEnable) {
        this.enableStyle.zIndex="7001";
        this.isEnable = isEnable ? false : true;
      },
    },
  };

</script>
<style>
  .fvVideoMonitor .main {
    overflow: hidden;
    display: inline-block;
  }

  .fvVideoMonitor .left .p {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100% !important;
    height: 100% !important;
    background: #000;
    z-index: 9999;
    border: 1px solid #ddd;
    text-align: center;
    color: #fff;
  }

  .fvVideoMonitor .left {
    width: 100% !important;
    height: 100% !important;
    background: #000;
  }

  .fvVideoMonitor .left video {
    width: 100% !important;
    height: 100% !important;
  }
  .fvVideoMonitor{
    background: rgba(0,0,0,0);
  }
  /*模态框的样式*/
  .fvVideoMonitor .modal {
    position: fixed;
    font-family: Arial, Helvetica, sans-serif;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 99999;
    opacity: 1;
    -webkit-transition: opacity 400ms ease-in;
    -moz-transition: opacity 400ms ease-in;
    transition: opacity 400ms ease-in;
    pointer-events: auto;
  }

  /* .none {
    opacity: 0;
    pointer-events: none;
  } */

  .fvVideoMonitor .modal>div {
    width: 400px;
    position: relative;
    margin: 10% auto;
    padding: 5px 20px 13px 20px;
    border-radius: 10px;
    background: #fff;
    background: -moz-linear-gradient(#fff, #999);
    background: -webkit-linear-gradient(#fff, #999);
    background: -o-linear-gradient(#fff, #999);
  }
.fvVideoMonitor .settings{
  position: absolute;
  top: 45%;
  left: 0;
  cursor: pointer;
  z-index: 7000;
}
  /* .yes,
  .no {
    background: #606061;
    color: #ffffff;
    line-height: 25px;
    position: absolute;
    right: -12px;
    text-align: center;
    top: -10px;
    width: 24px;
    text-decoration: none;
    font-weight: bold;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    border-radius: 12px;
    -moz-box-shadow: 1px 1px 3px #000;
    -webkit-box-shadow: 1px 1px 3px #000;
    box-shadow: 1px 1px 3px #000;
    cursor: pointer;
  }

  .no {
    right: 24px;
  } */
  .fvVideoMonitor .showLeft div p{
    list-style: none;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color:#E9E9EA;
    cursor: pointer;
    /* margin-top: 10px; */
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left:10px;
    margin-left: 9%;
  }
  .fvVideoMonitor .showLeft div{
    position: absolute;
    left: 0;
    width: 100%;
    /* overflow: hidden; */

  text-overflow: ellipsis;
  height: 100%;
  white-space: nowrap;
  overflow: auto;
  }
  .fvVideoMonitor .videoElement{
    object-fit: cover
  }
  .fvVideoMonitor .showLeft div p:hover{
    background:rgba(0,0,0,0.4);
  }
  .fvVideoMonitor .showLeft{
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    width: 24% !important; 
    height: 100% !important;
    /* border: 1px solid #eee; */
    /* background: #1F2128; */
    /* overflow: auto; */
  }
  .fvVideoMonitor .showLeft div::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }

  .fvVideoMonitor .showLeft div::-webkit-scrollbar
    {
        height: 6px;
        width : 6px;
        background-color: #F5F5F5;
    }

    .fvVideoMonitor .showLeft div::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-image: -webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));
    }
  /* .yes:hover,
  .no:hover {
    background: #00d9ff;
  } */

</style>



// WEBPACK FOOTER //
// src/components/primitives/fvVideoMonitor/fvVideoMonitor.vue